var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container", attrs: { role: "main" } }, [
    _c(
      "article",
      [
        _c("div", { staticClass: "row my-2 text-right" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "a",
              {
                staticClass: "portal-back",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$router.go(-1)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fas fa-chevron-left",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("span", { staticClass: "back-link" }, [
                  _vm._v(_vm._s(_vm.$t("components.actions.back"))),
                ]),
              ]
            ),
          ]),
        ]),
        _c("card-data-component", {
          attrs: { tabs: _vm.tabs },
          scopedSlots: _vm._u([
            {
              key: "data",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "profile data-load",
                      class: { "sk-loading": _vm.isLoading },
                    },
                    [
                      _vm.isLoading ? _c("sk-spinner") : _vm._e(),
                      _c("article", [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("pages.profile.tabs.personal_data.general")
                            )
                          ),
                        ]),
                        _vm.userData
                          ? _c("form", [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-6" },
                                  [
                                    _c("suc-text-form-show-field", {
                                      attrs: {
                                        title: _vm.$t(
                                          "pages.profile.tabs.personal_data.employee_code"
                                        ),
                                        value: _vm.userData.employeeCode,
                                      },
                                    }),
                                    _c("suc-text-form-show-field", {
                                      attrs: {
                                        title: _vm.$t(
                                          "pages.profile.tabs.personal_data.name"
                                        ),
                                        value: _vm.userData.name,
                                      },
                                    }),
                                    _c("suc-text-form-show-field", {
                                      attrs: {
                                        title: _vm.$t(
                                          "pages.profile.tabs.personal_data.first_family_name"
                                        ),
                                        value: _vm.userData.firstFamilyName,
                                      },
                                    }),
                                    _c("suc-text-form-show-field", {
                                      attrs: {
                                        title: _vm.$t(
                                          "pages.profile.tabs.personal_data.second_family_name"
                                        ),
                                        value: _vm.userData.secondFamilyName,
                                      },
                                    }),
                                    _c("suc-text-form-show-field", {
                                      attrs: {
                                        title: _vm.$t(
                                          "pages.profile.tabs.personal_data.full_name"
                                        ),
                                        value: _vm.userData.fullName,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6" },
                                  [
                                    _c("suc-text-form-show-field", {
                                      attrs: {
                                        title: _vm.$t(
                                          "pages.profile.tabs.personal_data.company_phone"
                                        ),
                                        value: _vm.userData.phoneNo2,
                                      },
                                    }),
                                    _c("suc-text-form-show-field", {
                                      attrs: {
                                        title: _vm.$t(
                                          "pages.profile.tabs.personal_data.company_email"
                                        ),
                                        value: _vm.userData.companyEmail,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }